import {
  MEAL_TYPES,
  LEFTOVER_POLICIES,
  PANTRY_SUGGEST_MODES,
  defaultPlanningPreferences,
  normalizePlanningPreferences,
  normalizeMealPreference
} from '../utils/planningPreferences';

export default function PlanningPreferencesEditor({ value, onChange }) {
  const preferences = normalizePlanningPreferences(value || defaultPlanningPreferences());

  const updateMealType = (mealType, field, fieldValue) => {
    const next = {
      ...preferences,
      [mealType]: {
        ...preferences[mealType],
        [field]: fieldValue
      }
    };
    onChange(next);
  };

  return (
    <div className="border-t pt-4 space-y-4">
      <div>
        <h3 className="text-lg font-semibold mb-1">Leftovers &amp; repeats</h3>
        <p className="text-sm text-gray-600 mb-4">
          Control how the planner handles portion leftovers per meal type. Lunches use portions quickly; dinners and freezer items wait at least the minimum gap (default 30 days).
        </p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left p-2 font-medium">Meal</th>
              <th className="text-left p-2 font-medium">Portions / meal</th>
              <th className="text-left p-2 font-medium">Variety window (days)</th>
              <th className="text-left p-2 font-medium">Leftover policy</th>
              <th className="text-left p-2 font-medium">Min gap for leftovers (days)</th>
              <th className="text-left p-2 font-medium">Pantry suggestions</th>
            </tr>
          </thead>
          <tbody>
            {MEAL_TYPES.map((mealType) => (
              <tr key={mealType} className="border-t border-gray-100">
                <td className="p-2 capitalize font-medium">{mealType}</td>
                <td className="p-2">
                  <input
                    type="number"
                    min="1"
                    value={preferences[mealType].portionsPerMeal}
                    onChange={(e) => updateMealType(mealType, 'portionsPerMeal', Number(e.target.value))}
                    className="w-20 p-1.5 border border-gray-300 rounded"
                  />
                </td>
                <td className="p-2">
                  <input
                    type="number"
                    min="0"
                    value={preferences[mealType].varietyWindowDays}
                    onChange={(e) => updateMealType(mealType, 'varietyWindowDays', Number(e.target.value))}
                    className="w-20 p-1.5 border border-gray-300 rounded"
                  />
                </td>
                <td className="p-2">
                  <select
                    value={preferences[mealType].leftoverPolicy}
                    onChange={(e) => updateMealType(mealType, 'leftoverPolicy', e.target.value)}
                    className="w-full min-w-[12rem] p-1.5 border border-gray-300 rounded"
                  >
                    {LEFTOVER_POLICIES.filter(
                      (option) => mealType !== 'lunch' || option.value !== 'freeze_inventory'
                    ).map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </td>
                <td className="p-2">
                  <input
                    type="number"
                    min="0"
                    value={preferences[mealType].leftoverMinGapDays}
                    onChange={(e) =>
                      updateMealType(mealType, 'leftoverMinGapDays', Number(e.target.value))
                    }
                    className="w-20 p-1.5 border border-gray-300 rounded"
                    title="Minimum days after cooking before planning leftover servings"
                  />
                </td>
                <td className="p-2">
                  <select
                    value={preferences[mealType].suggestFromPantry}
                    onChange={(e) => updateMealType(mealType, 'suggestFromPantry', e.target.value)}
                    className="w-full min-w-[10rem] p-1.5 border border-gray-300 rounded"
                  >
                    {PANTRY_SUGGEST_MODES.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export { normalizeMealPreference };
